// Início e término de um agendamento: as duas regras que impedem o par de ficar incoerente.
//
// 1) AUSÊNCIA NÃO VIRA DATA. `new Date(null)` não é data inválida — é 1970-01-01T00:00:00Z, um valor
//    truthy, que não é NaN e que passa por qualquer teste de "tem data". Era assim que um término
//    ausente virava 1970 e seguia até o banco (o backend repete o mesmo `new Date(dto.end)`).
//
// 2) O TÉRMINO MORA NO DIA DO INÍCIO. O campo de hora edita só HH:mm e mantém o dia do valor que já
//    tinha — ele não conhece o início. Com um término ancorado em 1969, a atendente corrigia a hora,
//    via "13:15 → 14:00" na tela e o salvar acusava "a hora final não pode ser anterior à hora
//    inicial", porque as datas estavam em dias diferentes.

// mesma duração mínima que o cálculo automático usa quando não há serviço escolhido
export const MINUTOS_MINIMOS = 10

export function dataOuNula(value: Date | string | number | null | undefined): Date | null {
    if (value === null || value === undefined || value === '') return null
    const date = value instanceof Date ? new Date(value.getTime()) : new Date(value)
    return isNaN(date.getTime()) ? null : date
}

// intervalo com que um agendamento novo abre, a partir do que a agenda selecionou. término ausente
// (ou anterior ao início, que é o que um 1970 herdado parece) sai do próprio início
export function intervaloInicial(dates: { start?: any; end?: any }): { start: Date; end: Date } {
    const start = dataOuNula(dates?.start)
    const end = dataOuNula(dates?.end)
    if (!start) return { start: null, end: null }
    if (end && end >= start) return { start, end }
    const fim = new Date(start)
    fim.setMinutes(fim.getMinutes() + MINUTOS_MINIMOS)
    return { start, end: fim }
}

// reconstrói o término no dia do início, preservando só a hora escolhida. chamar sempre que o campo
// de hora do término mexer no valor
export function ancorarTerminoNoInicio(start: Date | string, end: Date | string): Date | null {
    const inicio = dataOuNula(start)
    const termino = dataOuNula(end)
    if (!inicio || !termino) return termino
    const fim = new Date(inicio)
    fim.setHours(termino.getHours(), termino.getMinutes(), 0, 0)
    return fim
}
